import { defineMessages } from 'react-intl';

export default defineMessages({
    Accounts: {
        id: 'e1p.gateway.views.account-landing.Accounts',
        defaultMessage: 'Accounts'
    },
    RecentlyViewed: {
        id: 'e1p.gateway.views.account-landing.Recently Viewed',
        defaultMessage: 'Recently Viewed'
    },
    RecentlyCreated: {
        id: 'e1p.gateway.views.account-landing.Recently Created',
        defaultMessage: 'Recently Created'
    },
    AccountSearch: {
        id: 'e1p.gateway.views.account-landing.Account Search',
        defaultMessage: 'Account Search'
    },
    SearchResults: {
        id: 'e1p.gateway.views.account-landing.Search Results',
        defaultMessage: 'Search Results'
    },
    CommercialAccounts: {
        id: 'e1p.gateway.views.account-landing.Commercial Accounts',
        defaultMessage: 'Commercial Accounts'
    },
    Account: {
        id: 'e1p.gateway.views.account-landing.Account (name)',
        defaultMessage: 'Account (name)'
    },
    Policies: {
        id: 'e1p.gateway.views.account-detail.Number of Policies',
        defaultMessage: 'Number of Policies'
    },
    DateCreated: {
        id: 'e1p.gateway.views.account-landing.Created Date',
        defaultMessage: 'Date Created'
    },
    Address: {
        id: 'e1p.gateway.views.account-landing.Address',
        defaultMessage: 'Address'
    },
    OpenActivities: {
        id: 'e1p.gateway.views.account-landing.Open Activities',
        defaultMessage: 'Open Activities'
    },
    summary: {
        id: 'e1p.gateway.views.account-detail.Summary',
        defaultMessage: 'Summary',
    },
    contacts: {
        id: 'e1p.gateway.views.account-detail.Contacts',
        defaultMessage: 'Contacts'
    },
    openQuotes: {
        id: 'e1p.gateway.views.account-detail.Open Quotes',
        defaultMessage: 'Open Quotes'
    },
    openTransactions: {
        id: 'e1p.gateway.views.account-detail.Open Transactions',
        defaultMessage: 'Open Transactions'
    },
    completedTransaction: {
        id: 'e1p.gateway.views.account-detail.Completed Transactions',
        defaultMessage: 'Completed Transactions'
    },
    openActivities: {
        id: 'e1p.gateway.views.account-detail.Open Activities',
        defaultMessage: 'Open Activities'
    },
    claims: {
        id: 'e1p.gateway.views.account-detail.Claims',
        defaultMessage: 'Claims'
    },
    billingPayment: {
        id: 'e1p.gateway.views.account-detail.Billing & Payment',
        defaultMessage: 'Billing & Payment'
    },
    producerCode: {
        id: 'e1p.gateway.views.account-detail.Location Code(s)',
        defaultMessage: 'Location Code(s)'
    },
    premiumAmountLabel: {
        id: 'e1p.gateway.views.account-detail.Total Issued Premium',
        defaultMessage: 'Total Issued Premium'
    },
    renewals: {
        id: 'e1p.gateway.views.account-detail.Renewals',
        defaultMessage: '{num} Open Renewals'
    },
    cancellations: {
        id: 'e1p.gateway.views.account-detail.Cancellations',
        defaultMessage: '{num} Open Cancellations'
    },
    changes: {
        id: 'e1p.gateway.views.account-detail.Changes',
        defaultMessage: '{num} Open Changes'
    },
    customerSince: {
        id: 'e1p.gateway.views.account-detail.Customer Since',
        defaultMessage: 'Customer Since'
    },
    accountStatus: {
        id: 'e1p.gateway.views.account-detail.Account Status',
        defaultMessage: 'Account Status'
    },
    issuedPolicyLabel: {
        id: 'e1p.gateway.views.account-detail.Issued Policies',
        defaultMessage: 'Issued Policies'
    },
    newQuoteForAccount: {
        id: 'e1p.gateway.views.new-quote.New Quote for This Account',
        defaultMessage: 'New Quote for This Account'
    },
    productCode: {
        id: 'e1p.gateway.directives.PolicySummary.Product',
        defaultMessage: 'Product'
    },
    displayStatus: {
        id: 'e1p.gateway.directives.PolicySummary.Status',
        defaultMessage: 'Status'
    },
    policyNumber: {
        id: 'e1p.gateway.directives.PolicySummary.Policy Number',
        defaultMessage: 'Policy Number'
    },
    insuredName: {
        id: 'e1p.gateway.directives.PolicySummary.Named Insured',
        defaultMessage: 'Named Insured'
    },
    effectiveDate: {
        id: 'e1p.gateway.directives.PolicySummary.Effective Date',
        defaultMessage: 'Effective Date'
    },
    expirationDate: {
        id: 'e1p.gateway.directives.PolicySummary.Expiration Date',
        defaultMessage: 'Expiration Date'
    },
    accountContacts: {
        id: 'e1p.gateway.contacts.views.account-contact-detail.Account Contacts',
        defaultMessage: 'Account Contacts',
    },
    accountContactsCount: {
        id: 'e1p.gateway.contacts.views.account-contact-detail.Account Contacts Count',
        defaultMessage: 'Account Contacts {accountContactsCount}',
    },
    associatedContacts: {
        id: 'e1p.gateway.contacts.views.account-contact-detail.Associated Contacts',
        defaultMessage: 'Associated Contacts'
    },
    account: {
        id: 'e1p.gateway.views.account-detail.Account',
        defaultMessage: 'Account'
    },
    altBillingAccount: {
        id: 'e1p.gateway.views.account-detail.Alt Billing Account',
        defaultMessage: 'Alt Billing Account'
    },
    unbilledAmount: {
        id: 'e1p.gateway.views.account-detail.Unbilled',
        defaultMessage: 'Unbilled'
    },
    billedAmount: {
        id: 'e1p.gateway.views.account-detail.Billed Amount',
        defaultMessage: 'Billed Amount'
    },
    billedMonthly: {
        id: 'e1p.gateway.views.account-detail.Billed Monthly',
        defaultMessage: 'Billed Monthly'
    },
    invoiceStream: {
        id: 'e1p.gateway.directives.GatewayBillingPaymentLineInfo.Invoice Stream',
        defaultMessage: '{periodicity} Invoice Stream',
    },
    billingAccount: {
        id: 'e1p.gateway.views.account-detail.Billing Account',
        defaultMessage: 'Billing Account'
    },
    billingStatus: {
        id: 'e1p.gateway.views.account-detail.Billing Status',
        defaultMessage: 'Billing Status'
    },
    cancel: {
        id: 'e1p.gateway.views.account-detail.Cancel',
        defaultMessage: 'Cancel'
    },
    collateralHeld: {
        id: 'e1p.gateway.views.account-detail.Collateral Held',
        defaultMessage: 'Collateral Held'
    },
    collateralRequirement: {
        id: 'e1p.gateway.views.account-detail.Collateral Requirement',
        defaultMessage: 'Collateral Requirement'
    },
    currentPayment: {
        id: 'e1p.gateway.views.account-detail.Current Payment',
        defaultMessage: 'Current Payment'
    },
    delinquent: {
        id: 'e1p.gateway.views.account-detail.Delinquent',
        defaultMessage: 'Delinquent'
    },
    documents: {
        id: 'e1p.gateway.views.account-detail.Documents',
        defaultMessage: 'Documents'
    },
    edit: {
        id: 'e1p.gateway.views.account-detail.Edit',
        defaultMessage: 'Update Contact Info'
    },
    editContactDetails: {
        id: 'e1p.gateway.views.account-detail.Edit Contact Details',
        defaultMessage: 'Edit Contact Details'
    },
    email: {
        id: 'e1p.gateway.views.account-detail.Edit Contact Details.Email',
        defaultMessage: 'Email'
    },
    effDate: {
        id: 'e1p.gateway.views.account-detail.Eff Date',
        defaultMessage: 'Eff Date'
    },
    errorLoadingBillingData: {
        id: 'e1p.gateway.views.account-detail.Error loading billing data',
        defaultMessage: 'Error loading billing data'
    },
    expDate: {
        id: 'e1p.gateway.views.account-detail.Exp Date',
        defaultMessage: 'Exp Date'
    },
    inGoodStanding: {
        id: 'e1p.gateway.views.account-detail.In Good Standing',
        defaultMessage: 'In Good Standing'
    },
    invoice: {
        id: 'e1p.gateway.views.account-detail.Invoice',
        defaultMessage: 'Invoice #'
    },
    invoicesForLast12Months: {
        id: 'e1p.gateway.views.account-detail.Invoices for Last 12 Months',
        defaultMessage: 'Invoices for Last 12 Months'
    },
    makeAPayment: {
        id: 'e1p.gateway.views.account-detail.Make a Payment',
        defaultMessage: 'Make a Payment'
    },
    pastDue: {
        id: 'e1p.gateway.views.account-detail.Past Due',
        defaultMessage: 'Past Due'
    },
    nextDue: {
        id: 'e1p.gateway.directives.GatewayBillingPaymentLineInfo.Next Due',
        defaultMessage: 'Next Due'
    },
    nextDueDate: {
        id: 'e1p.gateway.directives.GatewayBillingPaymentLineInfo.Next Due Date',
        defaultMessage: 'Next Due on {firstUnpaidBillDueDate}'
    },
    pastDueDate: {
        id: 'e1p.gateway.directives.GatewayBillingPaymentLineInfo.Past Due Date',
        defaultMessage: 'Past Due on {overdueStatEarliestDate}'
    },
    payments: {
        id: 'e1p.gateway.views.account-detail.Payments',
        defaultMessage: 'Automatic Payments'
    },
    policiesBilledToThisAccount: {
        id: 'e1p.gateway.views.account-detail.Policies Billed to this Account',
        defaultMessage: 'Other Policies Billed to this Account'
    },
    policiesOwnedByThisAccount: {
        id: 'e1p.gateway.views.account-detail.Policies Owned by this Account',
        defaultMessage: 'Policies Owned by this Account'
    },
    customerPaymentSummary: {
        id: 'e1p.gateway.views.account-detail.Customer Payment Summary',
        defaultMessage: 'Customer Payment Summary'
    },
    policyTransactions: {
        id: 'e1p.gateway.views.account-detail.Policy Transactions',
        defaultMessage: 'Policy Transactions'
    },
    primaryContact: {
        id: 'e1p.gateway.views.account-detail.Primary Contact',
        defaultMessage: 'Primary Contact'
    },
    primaryPayer: {
        id: 'e1p.gateway.views.account-detail.Primary Payer',
        defaultMessage: 'Primary Payer'
    },
    status: {
        id: 'e1p.gateway.views.account-detail.Status',
        defaultMessage: 'Status'
    },
    noBillingData: {
        id: 'e1p.gateway.views.account-detail.No billing data for this account, check back again in the next',
        defaultMessage: 'No billing data for this account, check back again in the next 24 hours'
    },
    billing: {
        id: 'e1p.gateway.views.account-detail.Billing',
        defaultMessage: 'Billing'
    },
    automaticPayments: {
        id: 'e1p.gateway.views.account-detail.Automatic Payments',
        defaultMessage: 'Automatic Payments'
    },
    notInGoodStanding: {
        id: 'e1p.gateway.views.account-detail.Not In Good Standing',
        defaultMessage: 'Not In Good Standing'
    },
    producerCodes: {
        id: 'e1p.gateway.views.account-detail.Producer Codes',
        defaultMessage: 'Producer Code(s)'
    },
    policyNumberAccountDetail: {
        id: 'e1p.gateway.views.account-detail.Policy Number',
        defaultMessage: 'Policy Number'
    },
    product: {
        id: 'e1p.gateway.views.account-detail.Product',
        defaultMessage: 'Product'
    },
    quotes: {
        id: 'e1p.gateway.views.account-detail.Quotes',
        defaultMessage: 'Quotes'
    },
    saveChanges: {
        id: 'e1p.gateway.views.account-detail.Save Changes',
        defaultMessage: 'Save Changes'
    },
    saveFailedMessage: {
        id: 'e1p.gateway.views.account-detail.Save Failed Message',
        defaultMessage: 'Your changes were not saved.'
    },
    saveFailedTitle: {
        id: 'e1p.gateway.views.account-detail.Save Failed Title',
        defaultMessage: 'Failed to Save'
    },
    savedMessage: {
        id: 'e1p.gateway.views.account-detail.Saved Message',
        defaultMessage: 'Your changes have been saved.'
    },
    savedTitle: {
        id: 'e1p.gateway.views.account-detail.Saved Title',
        defaultMessage: 'Changes Saved'
    },
    searchTransactions: {
        id: 'e1p.gateway.views.account-detail.Search Transactions',
        defaultMessage: 'Search Transactions'
    },
    serviceTier: {
        id: 'e1p.gateway.views.account-detail.Service Tier',
        defaultMessage: 'Service Tier'
    },
    statementDate: {
        id: 'e1p.gateway.views.account-detail.Statement Date',
        defaultMessage: 'Statement Date'
    },
    thisAccountHasNoInvoices: {
        id: 'e1p.gateway.views.account-detail.This account has no invoices',
        defaultMessage: 'This account has no invoices'
    },
    thisAccountHasNoOwnedBilledPolicies: {
        id: 'e1p.gateway.views.account-detail.This account has no owned billed policies',
        defaultMessage: 'This account has no owned billed policies'
    },
    thisAccountHasNoUnownedBilledPolicies: {
        id: 'e1p.gateway.views.account-detail.This account has no unowned billed policies',
        defaultMessage: 'This account has no unowned billed policies'
    },
    totalDue: {
        id: 'e1p.gateway.views.account-detail.Total Due',
        defaultMessage: 'Total Due'
    },
    policiesAffected: {
        id: 'e1p.gateway.directives.GatewayBillingPaymentLineInfo.Policies Affected:',
        defaultMessage: 'Policies Affected:'
    },
    automaticPaymentsEnabled: {
        id: 'e1p.gateway.directives.GatewayBillingPaymentLineInfo.Automatic Payments are ENABLED',
        defaultMessage: 'Automatic Payments are ENABLED'
    },
    automaticPaymentsNotEnabled: {
        id: 'e1p.gateway.directives.GatewayBillingPaymentLineInfo.Automatic Payments are NOT enabled',
        defaultMessage: 'Automatic Payments are NOT enabled'
    },
    setupAutomaticPayment: {
        id: 'e1p.gateway.directives.GatewayBillingPaymentLineInfo.Set up Automatic Payments',
        defaultMessage: 'Set up Automatic Payments'
    },
    hidePaymentScheduleDetail: {
        id: 'e1p.billing.directives.templates.payment-line-info.Hide Payment Schedule Detail',
        defaultMessage: 'Hide Payment Schedule Detail'
    },
    viewPaymentScheduleDetail: {
        id: 'e1p.billing.directives.templates.payment-line-info.View Payment Schedule Detail',
        defaultMessage: 'View Payment Schedule Detail'
    },
    paid: {
        id: 'e1p.billing.directives.templates.policy-payment-schedule.Paid',
        defaultMessage: 'Paid'
    },
    unpaid: {
        id: 'e1p.billing.directives.templates.policy-payment-schedule.Unpaid',
        defaultMessage: 'Unpaid'
    },
    dueDate: {
        id: 'e1p.billing.directives.templates.payment-line-info.Due date',
        defaultMessage: 'Due date'
    },
    billStatus: {
        id: 'e1p.billing.directives.templates.payment-line-info.Bill Status',
        defaultMessage: 'Bill Status'
    },
    premium: {
        id: 'e1p.billing.directives.templates.payment-line-info.Premium',
        defaultMessage: 'Premium'
    },
    taxes: {
        id: 'e1p.billing.directives.templates.payment-line-info.Taxes',
        defaultMessage: 'Taxes'
    },
    fee: {
        id: 'e1p.billing.directives.templates.payment-line-info.Fee',
        defaultMessage: 'Fee'
    },
    totalPaid: {
        id: 'e1p.billing.directives.templates.payment-line-info.Total Paid',
        defaultMessage: 'Total Paid'
    },
    outstandingAmount: {
        id: 'e1p.billing.directives.templates.payment-line-info.Outstanding Amount',
        defaultMessage: 'Outstanding Amount'
    },
    invoiceNumber: {
        id: 'e1p.billing.directives.templates.payment-line-info.Invoice #',
        defaultMessage: 'Invoice #'
    },
    due: {
        id: 'e1p.billing.directives.templates.make-a-payment-form.Due',
        defaultMessage: 'Due'
    },
    billed: {
        id: 'e1p.billing.directives.templates.make-a-payment-form.Billed',
        defaultMessage: 'Billed'
    },
    carriedForward: {
        id: 'e1p.billing.directives.templates.make-a-payment-form.Carried Forward',
        defaultMessage: 'Carried Forward'
    },
    planned: {
        id: 'e1p.billing.directives.templates.make-a-payment-form.Planned',
        defaultMessage: 'Planned'
    },
    writtenOff: {
        id: 'e1p.billing.directives.templates.make-a-payment-form.Written Off',
        defaultMessage: 'Written Off'
    },
    configAllPolicyLines: {
        id: 'e1p.journey.config.All Policy Lines',
        defaultMessage: 'All Policy Lines'
    },
    configPersonalAuto: {
        id: 'e1p.journey.config.Personal Auto',
        defaultMessage: 'Personal Auto'
    },
    configHomeowners: {
        id: 'e1p.journey.config.Homeowners',
        defaultMessage: 'Homeowners'
    },
    configGeneric: {
        id: 'e1p.journey.config.Generic',
        defaultMessage: 'Generic'
    },
    accountContactChangedAccountContactChanged: {
        id: 'e1p.journey.event-templates.accountContactChanged.Account Contact Changed',
        defaultMessage: 'Account Contact Changed'
    },
    accountContactChangedAccountContactName: {
        id: 'e1p.journey.event-templates.accountContactChanged.Account Contact Name',
        defaultMessage: 'Name'
    },
    accountContactChangedAccountContactAddress: {
        id: 'e1p.journey.event-templates.accountContactChanged.Account Contact Address',
        defaultMessage: 'Address'
    },
    accountContactChangedAccountContactPhone: {
        id: 'e1p.journey.event-templates.accountContactChanged.Account Contact Phone',
        defaultMessage: 'Phone'
    },
    accountContactChangedAccountContactEmail: {
        id: 'e1p.journey.event-templates.accountContactChanged.Account Contact Email',
        defaultMessage: 'Email'
    },
    policyCancelledPolicyCancelled: {
        id: 'e1p.journey.event-templates.policyCancelled.Policy Cancelled',
        defaultMessage: 'Policy Cancelled'
    },
    policyChangeWithdrawnSubmissionWithdrown: {
        id: 'e1p.journey.event-templates.policyChangeWithdrawn.Submission Withdrown',
        defaultMessage: 'Policy Change Withdrawn'
    },
    policyChangeWithdrawnTransactionID: {
        id: 'e1p.journey.event-templates.policyChangeWithdrawn.Transaction ID',
        defaultMessage: 'Transaction ID'
    },
    policyReinstatedPolicyReinstated: {
        id: 'e1p.journey.event-templates.policyReinstated.Policy Reinstated',
        defaultMessage: 'Policy Reinstated'
    },
    policyReinstatedEffectiveDate: {
        id: 'e1p.journey.event-templates.policyReinstated.Effective Date',
        defaultMessage: 'Effective Date'
    },
    submisionWithdrawnSubmissionWithdrown: {
        id: 'e1p.journey.event-templates.submisionWithdrawn.Submission Withdrown',
        defaultMessage: 'Submission Withdrawn'
    },
    accountContactChangedPhone: {
        id: 'e1p.journey.event-templates.accountContactChanged.Phone',
        defaultMessage: 'Phone'
    },
    accountContactChangedAddress: {
        id: 'e1p.journey.event-templates.accountContactChanged.Address',
        defaultMessage: 'Address'
    },
    accountContactChangedEmail: {
        id: 'e1p.journey.event-templates.accountContactChanged.Email',
        defaultMessage: 'Email'
    },
    claimCreatedClaimCreated: {
        id: 'e1p.journey.event-templates.claimCreated.Claim Created',
        defaultMessage: 'Claim Created'
    },
    dateOfLoss: {
        id: 'e1p.journey.event-templates.claimCreated.Date Of Loss',
        defaultMessage: 'Date Of Loss'
    },
    claimCreatedClaimNumber: {
        id: 'e1p.journey.event-templates.claimCreated.Claim Number',
        defaultMessage: 'Claim Number'
    },
    claimCreatedLossInformation: {
        id: 'e1p.journey.event-templates.claimCreated.Loss Information',
        defaultMessage: 'Loss Information'
    },
    claimCreatedDateOfFNOL: {
        id: 'e1p.journey.event-templates.claimCreated.Date Of FNOL',
        defaultMessage: 'Date Of FNOL'
    },
    claimCreatedLossCause: {
        id: 'e1p.journey.event-templates.claimCreated.Loss Cause',
        defaultMessage: 'Loss Cause'
    },
    claimReassignedClaimReassigned: {
        id: 'e1p.journey.event-templates.claimReassigned.Claim Reassigned',
        defaultMessage: 'Claim Reassigned'
    },
    claimReassignedClaimNumber: {
        id: 'e1p.journey.event-templates.claimReassigned.Claim Number',
        defaultMessage: 'Claim Number'
    },
    claimReassignedAssignmentDate: {
        id: 'e1p.journey.event-templates.claimReassigned.Assignment Date',
        defaultMessage: 'Assignment Date'
    },
    claimReassignedAssignedAgentName: {
        id: 'e1p.journey.event-templates.claimReassigned.Assigned Agent Name',
        defaultMessage: 'Assigned Agent Name'
    },
    claimReassignedAssignedAgentPhone: {
        id: 'e1p.journey.event-templates.claimReassigned.Assigned Agent Phone',
        defaultMessage: 'Assigned Agent Phone'
    },
    claimReassignedAssignedAgentEmail: {
        id: 'e1p.journey.event-templates.claimReassigned.Assigned Agent Email',
        defaultMessage: 'Assigned Agent Email'
    },
    claimClosedClaimClosed: {
        id: 'e1p.journey.event-templates.claimClosed.Claim Closed',
        defaultMessage: 'Claim Closed'
    },
    claimClosedClaimNumber: {
        id: 'e1p.journey.event-templates.claimClosed.Claim Number',
        defaultMessage: 'Claim Number'
    },
    paymentPlanChangedPaymentPlanChanged: {
        id: 'e1p.journey.event-templates.paymentPlanChanged.Payment Plan Changed',
        defaultMessage: 'Payment Plan Changed'
    },
    paymentPlanChangedPaymentPlan: {
        id: 'e1p.journey.event-templates.paymentPlanChanged.Payment Plan',
        defaultMessage: 'Payment Plan'
    },
    serviceEstimateApprovedServiceEstimateApproved: {
        id: 'e1p.journey.event-templates.serviceEstimateApproved.Service Estimate Approved',
        defaultMessage: 'Service Estimate Approved'
    },
    serviceEstimateApprovedClaimNumber: {
        id: 'e1p.journey.event-templates.serviceEstimateApproved.Claim Number',
        defaultMessage: 'Claim Number'
    },
    serviceEstimateApprovedServiceRequestReferenceNumber: {
        id: 'e1p.journey.event-templates.serviceEstimateApproved.Service Request Reference Number',
        defaultMessage: 'Service Request Reference Number'
    },
    serviceEstimateApprovedServiceRequestEstimateNumber: {
        id: 'e1p.journey.event-templates.serviceEstimateApproved.Service Request Estimate Number',
        defaultMessage: 'Service Request Estimate Number'
    },
    serviceEstimateApprovedApprovedDate: {
        id: 'e1p.journey.event-templates.serviceEstimateApproved.Approved Date',
        defaultMessage: 'Approved Date'
    },
    serviceEstimateApprovedApprovedBy: {
        id: 'e1p.journey.event-templates.serviceEstimateApproved.Approved By',
        defaultMessage: 'Approved By'
    },
    serviceEstimateApprovedVendorName: {
        id: 'e1p.journey.event-templates.serviceEstimateApproved.Vendor Name',
        defaultMessage: 'Vendor Name'
    },
    serviceEstimateApprovedServiceType: {
        id: 'e1p.journey.event-templates.serviceEstimateApproved.Service Type',
        defaultMessage: 'Service Type'
    },
    serviceEstimateApprovedAmount: {
        id: 'e1p.journey.event-templates.serviceEstimateApproved.Amount',
        defaultMessage: 'Amount'
    },
    serviceInvoiceReceivedServiceInvoiceReceived: {
        id: 'e1p.journey.event-templates.serviceInvoiceReceived.Service Invoice Received',
        defaultMessage: 'Service Invoice Received'
    },
    serviceInvoiceReceivedClaimNumber: {
        id: 'e1p.journey.event-templates.serviceInvoiceReceived.Claim Number',
        defaultMessage: 'Claim Number'
    },
    serviceInvoiceReceivedServiceRequestNumber: {
        id: 'e1p.journey.event-templates.serviceInvoiceReceived.Service Request Number',
        defaultMessage: 'Service Request Number'
    },
    serviceInvoiceReceivedVendorName: {
        id: 'e1p.journey.event-templates.serviceInvoiceReceived.Vendor Name',
        defaultMessage: 'Vendor Name'
    },
    serviceInvoiceReceivedVendorID: {
        id: 'e1p.journey.event-templates.serviceInvoiceReceived.Vendor ID',
        defaultMessage: 'Vendor ID'
    },
    serviceInvoiceReceivedServiceType: {
        id: 'e1p.journey.event-templates.serviceInvoiceReceived.Service Type',
        defaultMessage: 'Service Type'
    },
    serviceInvoiceReceivedAmount: {
        id: 'e1p.journey.event-templates.serviceInvoiceReceived.Amount',
        defaultMessage: 'Amount'
    },
    serviceInvoiceReceivedDescription: {
        id: 'e1p.journey.event-templates.serviceInvoiceReceived.Description',
        defaultMessage: 'Description'
    },
    serviceInvoiceReceivedEstimateInvoiceID: {
        id: 'e1p.journey.event-templates.serviceInvoiceReceived.Estimate / Invoice ID',
        defaultMessage: 'Estimate / Invoice ID'
    },
    serviceAssignedServiceAssigned: {
        id: 'e1p.journey.event-templates.serviceAssigned.Service Assigned',
        defaultMessage: 'Service Assigned'
    },
    serviceAssignedClaimNumber: {
        id: 'e1p.journey.event-templates.serviceAssigned.Claim Number',
        defaultMessage: 'Claim Number'
    },
    serviceAssignedServiceRequestReferenceNumber: {
        id: 'e1p.journey.event-templates.serviceAssigned.Service Request Reference Number',
        defaultMessage: 'Service Request Reference Number'
    },
    serviceAssignedVendorName: {
        id: 'e1p.journey.event-templates.serviceAssigned.Vendor Name',
        defaultMessage: 'Vendor Name'
    },
    serviceAssignedVendorID: {
        id: 'e1p.journey.event-templates.serviceAssigned.Vendor ID',
        defaultMessage: 'Vendor ID'
    },
    serviceAssignedRequestedQuoteCompletionDate: {
        id: 'e1p.journey.event-templates.serviceAssigned.Requested Quote Completion Date',
        defaultMessage: 'Requested Quote Completion Date'
    },
    serviceAssignedExpectedQuoteCompletionDate: {
        id: 'e1p.journey.event-templates.serviceAssigned.Expected Quote Completion Date',
        defaultMessage: 'Expected Quote Completion Date'
    },
    serviceAssignedServiceType: {
        id: 'e1p.journey.event-templates.serviceAssigned.Service Type',
        defaultMessage: 'Service Type'
    },
    newAccountContactBillingContactAdded: {
        id: 'e1p.journey.event-templates.newAccountContact.Billing Contact Added',
        defaultMessage: 'Billing Contact Added'
    },
    newAccountContactAddress: {
        id: 'e1p.journey.event-templates.newAccountContact.Address',
        defaultMessage: 'Address'
    },
    newAccountContactName: {
        id: 'e1p.journey.event-templates.newAccountContact.Name',
        defaultMessage: 'Name'
    },
    newAccountContactPhone: {
        id: 'e1p.journey.event-templates.newAccountContact.Phone',
        defaultMessage: 'Phone'
    },
    newAccountContactEmail: {
        id: 'e1p.journey.event-templates.newAccountContact.Email',
        defaultMessage: 'Email'
    },
    removedAccountContactBillingContactDeleted: {
        id: 'e1p.journey.event-templates.removedAccountContact.Billing Contact Deleted',
        defaultMessage: 'Billing Contact Deleted'
    },
    removedAccountContactName: {
        id: 'e1p.journey.event-templates.removedAccountContact.Name',
        defaultMessage: 'Name'
    },
    removedAccountContactAddress: {
        id: 'e1p.journey.event-templates.removedAccountContact.Address',
        defaultMessage: 'Address'
    },
    removedAccountContactPhone: {
        id: 'e1p.journey.event-templates.removedAccountContact.Phone',
        defaultMessage: 'Phone'
    },
    removedAccountContactEmail: {
        id: 'e1p.journey.event-templates.removedAccountContact.Email',
        defaultMessage: 'Email'
    },
    catastropheAddedCatastropheAddedtoaClaim: {
        id: 'e1p.journey.event-templates.catastropheAdded.Catastrophe Added to a Claim',
        defaultMessage: 'Catastrophe Added to a Claim'
    },
    catastropheAddedClaimNumber: {
        id: 'e1p.journey.event-templates.catastropheAdded.Claim Number',
        defaultMessage: 'Claim Number'
    },
    catastropheAddedCatastropheName: {
        id: 'e1p.journey.event-templates.catastropheAdded.Catastrophe Name',
        defaultMessage: 'Catastrophe Name'
    },
    catastropheAddedCatastropheNumber: {
        id: 'e1p.journey.event-templates.catastropheAdded.Catastrophe Number',
        defaultMessage: 'Catastrophe Number'
    },
    contactChangedContactChanged: {
        id: 'e1p.journey.event-templates.contactChanged.Contact Changed',
        defaultMessage: 'Billing Contact Changed'
    },
    contactChangedName: {
        id: 'e1p.journey.event-templates.contactChanged.Name',
        defaultMessage: 'Name'
    },
    contactChangedPhone: {
        id: 'e1p.journey.event-templates.contactChanged.Phone',
        defaultMessage: 'Phone'
    },
    contactChangedAddress: {
        id: 'e1p.journey.event-templates.contactChanged.Address',
        defaultMessage: 'Address'
    },
    contactChangedEmail: {
        id: 'e1p.journey.event-templates.contactChanged.Email',
        defaultMessage: 'Email'
    },
    submissionCreatedSubmissionCreated: {
        id: 'e1p.journey.event-templates.submissionCreated.Submission Created',
        defaultMessage: 'Submission Created'
    },
    delinquencyProcessStartedAndInceptedDelinquencyStarted: {
        id: 'e1p.journey.event-templates.delinquencyProcessStartedAndIncepted.Delinquency Started',
        defaultMessage: 'Delinquency Started'
    },
    delinquencyProcessStartedAndInceptedAccountNumber: {
        id: 'e1p.journey.event-templates.delinquencyProcessStartedAndIncepted.Account Number',
        defaultMessage: 'Account Number'
    },
    delinquencyProcessStartedAndInceptedPolicyNumber: {
        id: 'e1p.journey.event-templates.delinquencyProcessStartedAndIncepted.Policy Number',
        defaultMessage: 'Policy Number'
    },
    delinquencyProcessStartedAndInceptedAmountDue: {
        id: 'e1p.journey.event-templates.delinquencyProcessStartedAndIncepted.Amount Due',
        defaultMessage: 'Amount Due'
    },
    delinquencyProcessStartedAndInceptedLateFee: {
        id: 'e1p.journey.event-templates.delinquencyProcessStartedAndIncepted.Late Fee',
        defaultMessage: 'Late Fee'
    },
    delinquencyProcessStartedAndInceptedReinstatementFee: {
        id: 'e1p.journey.event-templates.delinquencyProcessStartedAndIncepted.Reinstatement Fee',
        defaultMessage: 'Reinstatement Fee'
    },
    delinquencyProcessStartedAndInceptedReason: {
        id: 'e1p.journey.event-templates.delinquencyProcessStartedAndIncepted.Reason',
        defaultMessage: 'Reason'
    },
    delinquencyProcessStartedAndInceptedStartDate: {
        id: 'e1p.journey.event-templates.delinquencyProcessStartedAndIncepted.Start Date',
        defaultMessage: 'Start Date'
    },
    delinquencyProcessStartedAndInceptedInceptionDate: {
        id: 'e1p.journey.event-templates.delinquencyProcessStartedAndIncepted.Inception Date',
        defaultMessage: 'Inception Date'
    },
    delinquencyProcessClosedDelinquencyClosed: {
        id: 'e1p.journey.event-templates.delinquencyProcessClosed.Delinquency Closed',
        defaultMessage: 'Delinquency Closed'
    },
    delinquencyProcessClosedAccountNumber: {
        id: 'e1p.journey.event-templates.delinquencyProcessClosed.Account Number',
        defaultMessage: 'Account Number'
    },
    delinquencyProcessClosedPolicyNumber: {
        id: 'e1p.journey.event-templates.delinquencyProcessClosed.Policy Number',
        defaultMessage: 'Policy Number'
    },
    delinquencyProcessClosedAmountDue: {
        id: 'e1p.journey.event-templates.delinquencyProcessClosed.Amount Due',
        defaultMessage: 'Amount Due'
    },
    delinquencyProcessClosedLateFee: {
        id: 'e1p.journey.event-templates.delinquencyProcessClosed.Late Fee',
        defaultMessage: 'Late Fee'
    },
    delinquencyProcessClosedReinstatementFee: {
        id: 'e1p.journey.event-templates.delinquencyProcessClosed.Reinstatement Fee',
        defaultMessage: 'Reinstatement Fee'
    },
    delinquencyProcessClosedReason: {
        id: 'e1p.journey.event-templates.delinquencyProcessClosed.Reason',
        defaultMessage: 'Reason'
    },
    delinquencyProcessClosedStartDate: {
        id: 'e1p.journey.event-templates.delinquencyProcessClosed.Start Date',
        defaultMessage: 'Start Date'
    },
    delinquencyProcessClosedInceptionDate: {
        id: 'e1p.journey.event-templates.delinquencyProcessClosed.Inception Date',
        defaultMessage: 'Inception Date'
    },
    delinquencyProcessClosedExitDate: {
        id: 'e1p.journey.event-templates.delinquencyProcessClosed.Exit Date',
        defaultMessage: 'Exit Date'
    },
    primaryPayerChangedPrimaryPayerChanged: {
        id: 'e1p.journey.event-templates.primaryPayerChanged.Primary Payer Changed',
        defaultMessage: 'Primary Payer Changed'
    },
    primaryPayerChangedPayer: {
        id: 'e1p.journey.event-templates.primaryPayerChanged.Payer',
        defaultMessage: 'Payer'
    },
    primaryPayerChangedAddress: {
        id: 'e1p.journey.event-templates.primaryPayerChanged.Address',
        defaultMessage: 'Address'
    },
    primaryPayerChangedEmail: {
        id: 'e1p.journey.event-templates.primaryPayerChanged.Email',
        defaultMessage: 'Email'
    },
    primaryPayerChangedPhone: {
        id: 'e1p.journey.event-templates.primaryPayerChanged.Phone',
        defaultMessage: 'Phone'
    },
    policyPolicyNumber: {
        id: 'e1p.journey.event-templates.policy.Policy Number',
        defaultMessage: 'Policy Number'
    },
    policyEffectiveDate: {
        id: 'e1p.journey.event-templates.policy.Effective Date',
        defaultMessage: 'Effective Date'
    },
    policyCancelledReason: {
        id: 'e1p.journey.event-templates.policyCancelled.Reason',
        defaultMessage: 'Reason'
    },
    policyCancelledSource: {
        id: 'e1p.journey.event-templates.policyCancelled.Source',
        defaultMessage: 'Source'
    },
    policyCancelledDescription: {
        id: 'e1p.journey.event-templates.policyCancelled.Description',
        defaultMessage: 'Description'
    },
    policyIssuedPolicyIssued: {
        id: 'e1p.journey.event-templates.policyIssued.Policy Issued',
        defaultMessage: 'Policy Issued'
    },
    policyIssuedEffectiveDate: {
        id: 'e1p.journey.event-templates.policyIssued.Effective Date',
        defaultMessage: 'Effective Date'
    },
    policyIssuedTotalAmount: {
        id: 'e1p.journey.event-templates.policyIssued.Total Amount',
        defaultMessage: 'Total Amount'
    },
    policyIssuedSubmissionNumber: {
        id: 'e1p.journey.event-templates.policyIssued.Submission Number',
        defaultMessage: 'Submission Number'
    },
    policyIssuedExpirationDate: {
        id: 'e1p.journey.event-templates.policyIssued.Expiration Date',
        defaultMessage: 'Expiration Date'
    },
    policyIssuedPaymentPlan: {
        id: 'e1p.journey.event-templates.policyIssued.Payment Plan',
        defaultMessage: 'Payment Plan'
    },
    quoteShowedJobID: {
        id: 'e1p.journey.event-templates.quoteShowed.JobID',
        defaultMessage: 'JobID'
    },
    quoteShowedQuoteShowed: {
        id: 'e1p.journey.event-templates.quoteShowed.Quote Showed',
        defaultMessage: 'Quote Showed'
    },
    quoteShowedOffering: {
        id: 'e1p.journey.event-templates.quoteShowed.Offering',
        defaultMessage: 'Offering'
    },
    quoteShowedTotalPremium: {
        id: 'e1p.journey.event-templates.quoteShowed.Total Premium',
        defaultMessage: 'Total Premium'
    },
    accountLevelDueDateChangedPaymentDueDateChanged: {
        id: 'e1p.journey.event-templates.accountLevelDueDateChanged.Payment Due Date Changed',
        defaultMessage: 'Payment Due Date Changed'
    },
    accountLevelDueDateChangedMonthlyPaymentDueDate: {
        id: 'e1p.journey.event-templates.accountLevelDueDateChanged.Monthly Payment Due Date',
        defaultMessage: 'Monthly Payment Due Date'
    },
    accountLevelDueDateChangedWeeklyPaymentDueDay: {
        id: 'e1p.journey.event-templates.accountLevelDueDateChanged.Weekly Payment Due Day',
        defaultMessage: 'Weekly Payment Due Day'
    },
    accountLevelDueDateChangedFirstMonthlyPaymentDueDate: {
        id: 'e1p.journey.event-templates.accountLevelDueDateChanged.First Monthly Payment Due Date',
        defaultMessage: 'First Monthly Payment Due Date'
    },
    accountLevelDueDateChangedSecondMonthlyPaymentDueDate: {
        id: 'e1p.journey.event-templates.accountLevelDueDateChanged.Second Monthly Payment Due Date',
        defaultMessage: 'Second Monthly Payment Due Date'
    },
    accountLevelDueDateChangedFortnightlyPaymentDueDate: {
        id: 'e1p.journey.event-templates.accountLevelDueDateChanged.Fortnightly Payment Due Date',
        defaultMessage: 'Fortnightly Payment Due Date'
    },
    policyLevelDueDateChangedPaymentDueDateChanged: {
        id: 'e1p.journey.event-templates.policyLevelDueDateChanged.Payment Due Date Changed',
        defaultMessage: 'Payment Due Date Changed'
    },
    policyLevelDueDateChangedPaymentDueDate: {
        id: 'e1p.journey.event-templates.policyLevelDueDateChanged.Payment Due Date',
        defaultMessage: 'Payment Due Date'
    },
    invoiceBilledInvoiceBilled: {
        id: 'e1p.journey.event-templates.invoiceBilled.Invoice Billed',
        defaultMessage: 'Invoice Billed'
    },
    invoiceBilledInvoiceNumber: {
        id: 'e1p.journey.event-templates.invoiceBilled.Invoice Number',
        defaultMessage: 'Invoice Number'
    },
    invoiceBilledInvoiceTotal: {
        id: 'e1p.journey.event-templates.invoiceBilled.Invoice Total',
        defaultMessage: 'Invoice Total'
    },
    invoiceBilledStatus: {
        id: 'e1p.journey.event-templates.invoiceBilled.Status',
        defaultMessage: 'Status'
    },
    invoiceBilledBilledDate: {
        id: 'e1p.journey.event-templates.invoiceBilled.Billed Date',
        defaultMessage: 'Billed Date'
    },
    invoiceBilledDueDate: {
        id: 'e1p.journey.event-templates.invoiceBilled.Due Date',
        defaultMessage: 'Due Date'
    },
    invoiceBilledPaid: {
        id: 'e1p.journey.event-templates.invoiceBilled.Paid',
        defaultMessage: 'Paid'
    },
    invoiceBilledDue: {
        id: 'e1p.journey.event-templates.invoiceBilled.Due',
        defaultMessage: 'Due'
    },
    invoiceDueInvoiceDue: {
        id: 'e1p.journey.event-templates.invoiceDue.Invoice Due',
        defaultMessage: 'Invoice Due'
    },
    invoiceDueInvoiceNumber: {
        id: 'e1p.journey.event-templates.invoiceDue.Invoice Number',
        defaultMessage: 'Invoice Number'
    },
    invoiceDueInvoiceTotal: {
        id: 'e1p.journey.event-templates.invoiceDue.Invoice Total',
        defaultMessage: 'Invoice Total'
    },
    invoiceDueStatus: {
        id: 'e1p.journey.event-templates.invoiceDue.Status',
        defaultMessage: 'Status'
    },
    invoiceDueBilledDate: {
        id: 'e1p.journey.event-templates.invoiceDue.Billed Date',
        defaultMessage: 'Billed Date'
    },
    invoiceDueDueDate: {
        id: 'e1p.journey.event-templates.invoiceDue.Due Date',
        defaultMessage: 'Due Date'
    },
    invoiceDuePaid: {
        id: 'e1p.journey.event-templates.invoiceDue.Paid',
        defaultMessage: 'Paid'
    },
    invoiceDueDue: {
        id: 'e1p.journey.event-templates.invoiceDue.Due',
        defaultMessage: 'Due'
    },
    invoicePaidInvoicePaid: {
        id: 'e1p.journey.event-templates.invoicePaid.Invoice Paid',
        defaultMessage: 'Invoice Paid'
    },
    invoicePaidInvoiceNumber: {
        id: 'e1p.journey.event-templates.invoicePaid.Invoice Number',
        defaultMessage: 'Invoice Number'
    },
    invoicePaidInvoiceTotal: {
        id: 'e1p.journey.event-templates.invoicePaid.Invoice Total',
        defaultMessage: 'Invoice Total'
    },
    invoicePaidStatus: {
        id: 'e1p.journey.event-templates.invoicePaid.Status',
        defaultMessage: 'Status'
    },
    invoicePaidBilledDate: {
        id: 'e1p.journey.event-templates.invoicePaid.Billed Date',
        defaultMessage: 'Billed Date'
    },
    invoicePaidDueDate: {
        id: 'e1p.journey.event-templates.invoicePaid.Due Date',
        defaultMessage: 'Due Date'
    },
    invoicePaidPaid: {
        id: 'e1p.journey.event-templates.invoicePaid.Paid',
        defaultMessage: 'Paid'
    },
    invoicePaidDue: {
        id: 'e1p.journey.event-templates.invoicePaid.Due',
        defaultMessage: 'Due'
    },
    claimOpenedClaimOpened: {
        id: 'e1p.journey.event-templates.claimOpened.Claim Opened',
        defaultMessage: 'Claim Opened'
    },
    claimOpenedClaimNumber: {
        id: 'e1p.journey.event-templates.claimOpened.Claim Number',
        defaultMessage: 'Claim Number'
    },
    claimOpenedLossInformation: {
        id: 'e1p.journey.event-templates.claimOpened.Loss Information',
        defaultMessage: 'Loss Information'
    },
    claimOpenedDateOfLoss: {
        id: 'e1p.journey.event-templates.claimOpened.Date of Loss',
        defaultMessage: 'Date of Loss'
    },
    claimOpenedDateofFNOL: {
        id: 'e1p.journey.event-templates.claimOpened.Date of FNOL',
        defaultMessage: 'Date of FNOL'
    },
    claimOpenedLossCause: {
        id: 'e1p.journey.event-templates.claimOpened.Loss Cause',
        defaultMessage: 'Loss Cause'
    },
    disbursementSentDisbursementAmount: {
        id: 'e1p.journey.event-templates.disbursementSent.Disbursement Amount',
        defaultMessage: 'Disbursement Amount'
    },
    disbursementSentDisbursementSent: {
        id: 'e1p.journey.event-templates.disbursementSent.Disbursement Sent',
        defaultMessage: 'Disbursement Sent'
    },
    disbursementSentIssueDate: {
        id: 'e1p.journey.event-templates.disbursementSent.Issue Date',
        defaultMessage: 'Issue Date'
    },
    disbursementSentMemo: {
        id: 'e1p.journey.event-templates.disbursementSent.Memo',
        defaultMessage: 'Memo'
    },
    disbursementSentPayTo: {
        id: 'e1p.journey.event-templates.disbursementSent.Pay To',
        defaultMessage: 'Pay To'
    },
    disbursementSentReason: {
        id: 'e1p.journey.event-templates.disbursementSent.Reason',
        defaultMessage: 'Reason'
    },
    writeOffAddedWriteOff: {
        id: 'e1p.journey.event-templates.writeOffAdded.Write Off',
        defaultMessage: 'Write Off'
    },
    writeOffAddedDate: {
        id: 'e1p.journey.event-templates.writeOffAdded.Date',
        defaultMessage: 'Date'
    },
    writeOffAddedCharge: {
        id: 'e1p.journey.event-templates.writeOffAdded.Charge',
        defaultMessage: 'Charge'
    },
    writeOffAddedReason: {
        id: 'e1p.journey.event-templates.writeOffAdded.Reason',
        defaultMessage: 'Reason'
    },
    writeOffAddedInvoices: {
        id: 'e1p.journey.event-templates.writeOffAdded.Invoices',
        defaultMessage: 'Invoices'
    },
    writeOffReversalAddedWriteOffReversal: {
        id: 'e1p.journey.event-templates.writeOffReversalAdded.Write Off Reversal',
        defaultMessage: 'Write Off Reversed'
    },
    writeOffReversalAddedReversalReason: {
        id: 'e1p.journey.event-templates.writeOffReversalAdded.Reversal Reason',
        defaultMessage: 'Reversal Reason'
    },
    paymentReceivedPaymentReceived: {
        id: 'e1p.journey.event-templates.paymentReceived.Payment Received',
        defaultMessage: 'Payment Received'
    },
    paymentReceivedReceivedDate: {
        id: 'e1p.journey.event-templates.paymentReceived.Received Date',
        defaultMessage: 'Received Date'
    },
    paymentReceivedAmount: {
        id: 'e1p.journey.event-templates.paymentReceived.Amount',
        defaultMessage: 'Amount'
    },
    paymentReceivedReferenceNumber: {
        id: 'e1p.journey.event-templates.paymentReceived.Reference Number',
        defaultMessage: 'Reference Number'
    },
    paymentReceivedInvoiceNumber: {
        id: 'e1p.journey.event-templates.paymentReceived.Invoice Number',
        defaultMessage: 'Invoice Number'
    },
    paymentReceivedInvoiceNumbers: {
        id: 'e1p.journey.event-templates.paymentReceived.Invoice Numbers',
        defaultMessage: 'Invoice Numbers'
    },
    onetimePaymentReceivedOneTimePaymentReceived: {
        id: 'e1p.journey.event-templates.onetimePaymentReceived.One Time Payment Received',
        defaultMessage: 'One Time Payment Received'
    },
    onetimePaymentReceivedReceivedDate: {
        id: 'e1p.journey.event-templates.onetimePaymentReceived.Received Date',
        defaultMessage: 'Received Date'
    },
    onetimePaymentReceivedAmount: {
        id: 'e1p.journey.event-templates.onetimePaymentReceived.Amount',
        defaultMessage: 'Amount'
    },
    onetimePaymentReceivedReferenceNumber: {
        id: 'e1p.journey.event-templates.onetimePaymentReceived.Reference Number',
        defaultMessage: 'Reference Number'
    },
    onetimePaymentReceivedInvoiceNumber: {
        id: 'e1p.journey.event-templates.onetimePaymentReceived.Invoice Number',
        defaultMessage: 'Invoice Number'
    },
    onetimePaymentReceivedInvoiceNumbers: {
        id: 'e1p.journey.event-templates.onetimePaymentReceived.Invoice Numbers',
        defaultMessage: 'Invoice Numbers'
    },
    indemnityPaymentIndemnityPayment: {
        id: 'e1p.journey.event-templates.indemnityPayment.Indemnity Payment',
        defaultMessage: 'Indemnity Payment'
    },
    indemnityPaymentClaimNumber: {
        id: 'e1p.journey.event-templates.indemnityPayment.Claim Number',
        defaultMessage: 'Claim Number'
    },
    indemnityPaymentPayees: {
        id: 'e1p.journey.event-templates.indemnityPayment.Payees',
        defaultMessage: 'Payees'
    },
    indemnityPaymentCheckNumber: {
        id: 'e1p.journey.event-templates.indemnityPayment.Check Number',
        defaultMessage: 'Check Number'
    },
    indemnityPaymentExposureName: {
        id: 'e1p.journey.event-templates.indemnityPayment.Exposure Name',
        defaultMessage: 'Exposure Name'
    },
    indemnityPaymentAmount: {
        id: 'e1p.journey.event-templates.indemnityPayment.Amount',
        defaultMessage: 'Amount'
    },
    paymentReversedPaymentReversed: {
        id: 'e1p.journey.event-templates.paymentReversed.Payment Reversed',
        defaultMessage: 'Payment Reversed'
    },
    paymentReversedAmount: {
        id: 'e1p.journey.event-templates.paymentReversed.Amount',
        defaultMessage: 'Amount'
    },
    paymentReversedReceivedDate: {
        id: 'e1p.journey.event-templates.paymentReversed.Received Date',
        defaultMessage: 'Received Date'
    },
    paymentReversedReferenceNumber: {
        id: 'e1p.journey.event-templates.paymentReversed.Reference Number',
        defaultMessage: 'Reference Number'
    },
    paymentReversedReversalDate: {
        id: 'e1p.journey.event-templates.paymentReversed.Reversal Date',
        defaultMessage: 'Reversal Date'
    },
    paymentReversedReversalReason: {
        id: 'e1p.journey.event-templates.paymentReversed.Reversal Reason',
        defaultMessage: 'Reversal Reason'
    },
    paymentReversedInvoiceNumber: {
        id: 'e1p.journey.event-templates.paymentReversed.Invoice Number',
        defaultMessage: 'Invoice Number'
    },
    paymentReversedInvoiceNumbers: {
        id: 'e1p.journey.event-templates.paymentReversed.Invoice Numbers',
        defaultMessage: 'Invoice Numbers'
    },
    policyChangemortgageeAddedPolicyMortgageeAdded: {
        id: 'e1p.journey.event-templates.policyChange-mortgageeAdded.Policy Mortgagee Added',
        defaultMessage: 'Policy Mortgagee Added'
    },
    policyChangemortgageeAddedName: {
        id: 'e1p.journey.event-templates.policyChange-mortgageeAdded.Name',
        defaultMessage: 'Name'
    },
    policyChangemortgageeAddedAddress: {
        id: 'e1p.journey.event-templates.policyChange-mortgageeAdded.Address',
        defaultMessage: 'Address'
    },
    policyChangemortgageeAddedPhone: {
        id: 'e1p.journey.event-templates.policyChange-mortgageeAdded.Phone',
        defaultMessage: 'Phone'
    },
    policyChangemortgageeAddedEmail: {
        id: 'e1p.journey.event-templates.policyChange-mortgageeAdded.Email',
        defaultMessage: 'Email'
    },
    policyChangemortgageeAddedEffectiveDate: {
        id: 'e1p.journey.event-templates.policyChange-mortgageeAdded.Effective Date',
        defaultMessage: 'Effective Date'
    },
    policyChangemortgageeRemovedPolicyMortgageeRemoved: {
        id: 'e1p.journey.event-templates.policyChange-mortgageeRemoved.Policy Mortgagee Removed',
        defaultMessage: 'Policy Mortgagee Removed'
    },
    policyChangemortgageeRemovedName: {
        id: 'e1p.journey.event-templates.policyChange-mortgageeRemoved.Name',
        defaultMessage: 'Name'
    },
    policyChangemortgageeRemovedAddress: {
        id: 'e1p.journey.event-templates.policyChange-mortgageeRemoved.Address',
        defaultMessage: 'Address'
    },
    policyChangemortgageeRemovedPhone: {
        id: 'e1p.journey.event-templates.policyChange-mortgageeRemoved.Phone',
        defaultMessage: 'Phone'
    },
    policyChangemortgageeRemovedEmail: {
        id: 'e1p.journey.event-templates.policyChange-mortgageeRemoved.Email',
        defaultMessage: 'Email'
    },
    policyChangemortgageeRemovedEffectiveDate: {
        id: 'e1p.journey.event-templates.policyChange-mortgageeRemoved.Effective Date',
        defaultMessage: 'Effective Date'
    },
    policyChangemortgageeChangedPolicyMortgageeChanged: {
        id: 'e1p.journey.event-templates.policyChange-mortgageeChanged.Policy Mortgagee Changed',
        defaultMessage: 'Policy Mortgagee Changed'
    },
    policyChangemortgageeChangedName: {
        id: 'e1p.journey.event-templates.policyChange-mortgageeChanged.Name',
        defaultMessage: 'Name'
    },
    policyChangemortgageeChangedEffectiveDate: {
        id: 'e1p.journey.event-templates.policyChange-mortgageeChanged.Effective Date',
        defaultMessage: 'Effective Date'
    },
    policyChangevaluableAddedPolicyValuableAdded: {
        id: 'e1p.journey.event-templates.policyChange-valuableAdded.Policy Valuable Added',
        defaultMessage: 'Policy Valuable Added'
    },
    policyChangevaluableAddedType: {
        id: 'e1p.journey.event-templates.policyChange-valuableAdded.Type',
        defaultMessage: 'Type'
    },
    policyChangevaluableAddedDescription: {
        id: 'e1p.journey.event-templates.policyChange-valuableAdded.Description',
        defaultMessage: 'Description'
    },
    policyChangevaluableAddedValue: {
        id: 'e1p.journey.event-templates.policyChange-valuableAdded.Value',
        defaultMessage: 'Value'
    },
    policyChangevaluableRemovedPolicyValuableRemoved: {
        id: 'e1p.journey.event-templates.policyChange-valuableRemoved.Policy Valuable Removed',
        defaultMessage: 'Policy Valuable Removed'
    },
    policyChangevaluableRemovedType: {
        id: 'e1p.journey.event-templates.policyChange-valuableRemoved.Type',
        defaultMessage: 'Type'
    },
    policyChangevaluableRemovedDescription: {
        id: 'e1p.journey.event-templates.policyChange-valuableRemoved.Description',
        defaultMessage: 'Description'
    },
    policyChangevaluableRemovedValue: {
        id: 'e1p.journey.event-templates.policyChange-valuableRemoved.Value',
        defaultMessage: 'Value'
    },
    policyChangevaluableChangedPolicyValuableChanged: {
        id: 'e1p.journey.event-templates.policyChange-valuableChanged.Policy Valuable Changed',
        defaultMessage: 'Policy Valuable Changed'
    },
    policyChangevaluableChangedType: {
        id: 'e1p.journey.event-templates.policyChange-valuableChanged.Type',
        defaultMessage: 'Type'
    },
    policyChangevaluableChangedDescription: {
        id: 'e1p.journey.event-templates.policyChange-valuableChanged.Description',
        defaultMessage: 'Description'
    },
    policyChangevaluableChangedValue: {
        id: 'e1p.journey.event-templates.policyChange-valuableChanged.Value',
        defaultMessage: 'Value'
    },
    policyChangedriverAddedPolicyDriverAdded: {
        id: 'e1p.journey.event-templates.policyChange-driverAdded.Policy Driver Added',
        defaultMessage: 'Policy Driver Added'
    },
    policyChangedriverAddedName: {
        id: 'e1p.journey.event-templates.policyChange-driverAdded.Name',
        defaultMessage: 'Name'
    },
    policyChangedriverAddedAddress: {
        id: 'e1p.journey.event-templates.policyChange-driverAdded.Address',
        defaultMessage: 'Address'
    },
    policyChangedriverAddedPhone: {
        id: 'e1p.journey.event-templates.policyChange-driverAdded.Phone',
        defaultMessage: 'Phone'
    },
    policyChangedriverAddedEmail: {
        id: 'e1p.journey.event-templates.policyChange-driverAdded.Email',
        defaultMessage: 'Email'
    },
    policyChangedriverAddedEffectiveDate: {
        id: 'e1p.journey.event-templates.policyChange-driverAdded.Effective Date',
        defaultMessage: 'Effective Date'
    },
    policyChangedriverRemovedPolicyDriverRemoved: {
        id: 'e1p.journey.event-templates.policyChange-driverRemoved.Policy Driver Removed',
        defaultMessage: 'Policy Driver Removed'
    },
    policyChangedriverRemovedName: {
        id: 'e1p.journey.event-templates.policyChange-driverRemoved.Name',
        defaultMessage: 'Name'
    },
    policyChangedriverRemovedAddress: {
        id: 'e1p.journey.event-templates.policyChange-driverRemoved.Address',
        defaultMessage: 'Address'
    },
    policyChangedriverRemovedPhone: {
        id: 'e1p.journey.event-templates.policyChange-driverRemoved.Phone',
        defaultMessage: 'Phone'
    },
    policyChangedriverRemovedEmail: {
        id: 'e1p.journey.event-templates.policyChange-driverRemoved.Email',
        defaultMessage: 'Email'
    },
    policyChangedriverChangedPolicyDriverChanged: {
        id: 'e1p.journey.event-templates.policyChange-driverChanged.Policy Driver Changed',
        defaultMessage: 'Policy Driver Changed'
    },
    policyChangedriverChangedName: {
        id: 'e1p.journey.event-templates.policyChange-driverChanged.Name',
        defaultMessage: 'Name'
    },
    policyChangedriverChangedEffectiveDate: {
        id: 'e1p.journey.event-templates.policyChange-driverChanged.Effective Date',
        defaultMessage: 'Effective Date'
    },
    policyChangedriverRemovedEffectiveDate: {
        id: 'e1p.journey.event-templates.policyChange-driverRemoved.Effective Date',
        defaultMessage: 'Effective Date'
    },
    policyChangevehicleDriverAddedPolicyVehicleDriverAdded: {
        id: 'e1p.journey.event-templates.policyChange-vehicleDriverAdded.Policy Vehicle Driver Added',
        defaultMessage: 'Policy Vehicle Driver Added'
    },
    policyChangevehicleDriverAddedName: {
        id: 'e1p.journey.event-templates.policyChange-vehicleDriverAdded.Name',
        defaultMessage: 'Name'
    },
    policyChangevehicleDriverAddedAddress: {
        id: 'e1p.journey.event-templates.policyChange-vehicleDriverAdded.Address',
        defaultMessage: 'Address'
    },
    policyChangevehicleDriverAddedPhone: {
        id: 'e1p.journey.event-templates.policyChange-vehicleDriverAdded.Phone',
        defaultMessage: 'Phone'
    },
    policyChangevehicleDriverAddedEmail: {
        id: 'e1p.journey.event-templates.policyChange-vehicleDriverAdded.Email',
        defaultMessage: 'Email'
    },
    policyChangevehicleDriverAddedEffectiveDate: {
        id: 'e1p.journey.event-templates.policyChange-vehicleDriverAdded.Effective Date',
        defaultMessage: 'Effective Date'
    },
    policyChangevehicleDriverRemovedPolicyVehicleDriverRemoved: {
        id: 'e1p.journey.event-templates.policyChange-vehicleDriverRemoved.Policy Vehicle Driver Removed',
        defaultMessage: 'Policy Vehicle Driver Removed'
    },
    policyChangevehicleDriverRemovedName: {
        id: 'e1p.journey.event-templates.policyChange-vehicleDriverRemoved.Name',
        defaultMessage: 'Name'
    },
    policyChangevehicleDriverRemovedAddress: {
        id: 'e1p.journey.event-templates.policyChange-vehicleDriverRemoved.Address',
        defaultMessage: 'Address'
    },
    policyChangevehicleDriverRemovedPhone: {
        id: 'e1p.journey.event-templates.policyChange-vehicleDriverRemoved.Phone',
        defaultMessage: 'Phone'
    },
    policyChangevehicleDriverRemovedEmail: {
        id: 'e1p.journey.event-templates.policyChange-vehicleDriverRemoved.Email',
        defaultMessage: 'Email'
    },
    policyChangevehicleDriverRemovedEffectiveDate: {
        id: 'e1p.journey.event-templates.policyChange-vehicleDriverRemoved.Effective Date',
        defaultMessage: 'Effective Date'
    },
    policyChangevehicleAddedPolicyVehicleAdded: {
        id: 'e1p.journey.event-templates.policyChange-vehicleAdded.Policy Vehicle Added',
        defaultMessage: 'Policy Vehicle Added'
    },
    policyChangevehicleAddedVehicleNumber: {
        id: 'e1p.journey.event-templates.policyChange-vehicleAdded.Vehicle Number',
        defaultMessage: 'Vehicle Number'
    },
    policyChangevehicleAddedVehicleType: {
        id: 'e1p.journey.event-templates.policyChange-vehicleAdded.Vehicle Type',
        defaultMessage: 'Vehicle Type'
    },
    policyChangevehicleAddedVIN: {
        id: 'e1p.journey.event-templates.policyChange-vehicleAdded.VIN',
        defaultMessage: 'VIN'
    },
    policyChangevehicleAddedModelYear: {
        id: 'e1p.journey.event-templates.policyChange-vehicleAdded.Model Year',
        defaultMessage: 'Model Year'
    },
    policyChangevehicleAddedMake: {
        id: 'e1p.journey.event-templates.policyChange-vehicleAdded.Make',
        defaultMessage: 'Make'
    },
    policyChangevehicleAddedBodyType: {
        id: 'e1p.journey.event-templates.policyChange-vehicleAdded.Body Type',
        defaultMessage: 'Body Type'
    },
    policyChangevehicleAddedColor: {
        id: 'e1p.journey.event-templates.policyChange-vehicleAdded.Color',
        defaultMessage: 'Color'
    },
    policyChangevehicleAddedLicencePlate: {
        id: 'e1p.journey.event-templates.policyChange-vehicleAdded.Licence Plate',
        defaultMessage: 'Licence Plate'
    },
    policyChangevehicleAddedLicenceState: {
        id: 'e1p.journey.event-templates.policyChange-vehicleAdded.Licence State',
        defaultMessage: 'Licence State'
    },
    policyChangevehicleAddedPrimaryUse: {
        id: 'e1p.journey.event-templates.policyChange-vehicleAdded.Primary Use',
        defaultMessage: 'Primary Use'
    },
    policyChangevehicleAddedCostNew: {
        id: 'e1p.journey.event-templates.policyChange-vehicleAdded.Cost New',
        defaultMessage: 'Cost New'
    },
    policyChangevehicleAddedStatedValue: {
        id: 'e1p.journey.event-templates.policyChange-vehicleAdded.Stated Value',
        defaultMessage: 'Stated Value'
    },
    policyChangevehicleAddedAnnualMileage: {
        id: 'e1p.journey.event-templates.policyChange-vehicleAdded.Annual Mileage',
        defaultMessage: 'Annual Mileage'
    },
    policyChangevehicleAddedCommutingMiles: {
        id: 'e1p.journey.event-templates.policyChange-vehicleAdded.Commuting Miles',
        defaultMessage: 'Commuting Miles'
    },
    policyChangevehicleAddedEffectiveDate: {
        id: 'e1p.journey.event-templates.policyChange-vehicleAdded.Effective Date',
        defaultMessage: 'Effective Date'
    },
    policyChangevehicleRemovedPolicyVehicleRemoved: {
        id: 'e1p.journey.event-templates.policyChange-vehicleRemoved.Policy Vehicle Removed',
        defaultMessage: 'Policy Vehicle Removed'
    },
    policyChangevehicleRemovedVehicleNumber: {
        id: 'e1p.journey.event-templates.policyChange-vehicleRemoved.Vehicle Number',
        defaultMessage: 'Vehicle Number'
    },
    policyChangevehicleRemovedVehicleType: {
        id: 'e1p.journey.event-templates.policyChange-vehicleRemoved.Vehicle Type',
        defaultMessage: 'Vehicle Type'
    },
    policyChangevehicleRemovedVIN: {
        id: 'e1p.journey.event-templates.policyChange-vehicleRemoved.VIN',
        defaultMessage: 'VIN'
    },
    policyChangevehicleRemovedModelYear: {
        id: 'e1p.journey.event-templates.policyChange-vehicleRemoved.Model Year',
        defaultMessage: 'Model Year'
    },
    policyChangevehicleRemovedMake: {
        id: 'e1p.journey.event-templates.policyChange-vehicleRemoved.Make',
        defaultMessage: 'Make'
    },
    policyChangevehicleRemovedBodyType: {
        id: 'e1p.journey.event-templates.policyChange-vehicleRemoved.Body Type',
        defaultMessage: 'Body Type'
    },
    policyChangevehicleRemovedColor: {
        id: 'e1p.journey.event-templates.policyChange-vehicleRemoved.Color',
        defaultMessage: 'Color'
    },
    policyChangevehicleRemovedLicencePlate: {
        id: 'e1p.journey.event-templates.policyChange-vehicleRemoved.Licence Plate',
        defaultMessage: 'Licence Plate'
    },
    policyChangevehicleRemovedLicenceState: {
        id: 'e1p.journey.event-templates.policyChange-vehicleRemoved.Licence State',
        defaultMessage: 'Licence State'
    },
    policyChangevehicleRemovedCostNew: {
        id: 'e1p.journey.event-templates.policyChange-vehicleRemoved.Cost New',
        defaultMessage: 'Cost New'
    },
    policyChangevehicleRemovedStatedValue: {
        id: 'e1p.journey.event-templates.policyChange-vehicleRemoved.Stated Value',
        defaultMessage: 'Stated Value'
    },
    policyChangevehicleRemovedAnnualMileage: {
        id: 'e1p.journey.event-templates.policyChange-vehicleRemoved.Annual Mileage',
        defaultMessage: 'Annual Mileage'
    },
    policyChangevehicleRemovedCommutingMiles: {
        id: 'e1p.journey.event-templates.policyChange-vehicleRemoved.Commuting Miles',
        defaultMessage: 'Commuting Miles'
    },
    policyChangevehicleRemovedEffectiveDate: {
        id: 'e1p.journey.event-templates.policyChange-vehicleRemoved.Effective Date',
        defaultMessage: 'Effective Date'
    },
    policyChangevehicleChangedPolicyVehicleChanged: {
        id: 'e1p.journey.event-templates.policyChange-vehicleChanged.Policy Vehicle Changed',
        defaultMessage: 'Policy Vehicle Changed'
    },
    policyChangevehicleChangedVehicleNumber: {
        id: 'e1p.journey.event-templates.policyChange-vehicleChanged.Vehicle Number',
        defaultMessage: 'Vehicle Number'
    },
    policyChangevehicleChangedVehicleType: {
        id: 'e1p.journey.event-templates.policyChange-vehicleChanged.Vehicle Type',
        defaultMessage: 'Vehicle Type'
    },
    policyChangevehicleChangedVIN: {
        id: 'e1p.journey.event-templates.policyChange-vehicleChanged.VIN',
        defaultMessage: 'VIN'
    },
    policyChangevehicleChangedModelYear: {
        id: 'e1p.journey.event-templates.policyChange-vehicleChanged.Model Year',
        defaultMessage: 'Model Year'
    },
    policyChangevehicleChangedMake: {
        id: 'e1p.journey.event-templates.policyChange-vehicleChanged.Make',
        defaultMessage: 'Make'
    },
    policyChangevehicleChangedBodyType: {
        id: 'e1p.journey.event-templates.policyChange-vehicleChanged.Body Type',
        defaultMessage: 'Body Type'
    },
    policyChangevehicleChangedColor: {
        id: 'e1p.journey.event-templates.policyChange-vehicleChanged.Color',
        defaultMessage: 'Color'
    },
    policyChangevehicleChangedLicencePlate: {
        id: 'e1p.journey.event-templates.policyChange-vehicleChanged.Licence Plate',
        defaultMessage: 'Licence Plate'
    },
    policyChangevehicleChangedLicenceState: {
        id: 'e1p.journey.event-templates.policyChange-vehicleChanged.Licence State',
        defaultMessage: 'Licence State'
    },
    policyChangevehicleChangedCostNew: {
        id: 'e1p.journey.event-templates.policyChange-vehicleChanged.Cost New',
        defaultMessage: 'Cost New'
    },
    policyChangevehicleChangedStatedValue: {
        id: 'e1p.journey.event-templates.policyChange-vehicleChanged.Stated Value',
        defaultMessage: 'Stated Value'
    },
    policyChangevehicleChangedAnnualMileage: {
        id: 'e1p.journey.event-templates.policyChange-vehicleChanged.Annual Mileage',
        defaultMessage: 'Annual Mileage'
    },
    policyChangevehicleChangedCommutingMiles: {
        id: 'e1p.journey.event-templates.policyChange-vehicleChanged.Commuting Miles',
        defaultMessage: 'Commuting Miles'
    },
    policyChangevehicleChangedPrimaryUse: {
        id: 'e1p.journey.event-templates.policyChange-vehicleChanged.Primary Use',
        defaultMessage: 'Primary Use'
    },
    policyChangevehicleChangedEffectiveDate: {
        id: 'e1p.journey.event-templates.policyChange-vehicleChanged.Effective Date',
        defaultMessage: 'Effective Date'
    },
    policyChangeaddedCoveragesPolicyCoverageAdded: {
        id: 'e1p.journey.event-templates.policyChange-addedCoverages.Policy Coverage Added',
        defaultMessage: 'Policy Coverage Added'
    },
    policyChangeaddedCoveragesEffectiveDate: {
        id: 'e1p.journey.event-templates.policyChange-addedCoverages.Effective Date',
        defaultMessage: 'Effective Date'
    },
    policyChangeremovedCoveragesPolicyCoverageRemoved: {
        id: 'e1p.journey.event-templates.policyChange-removedCoverages.Policy Coverage Removed',
        defaultMessage: 'Policy Coverage Removed'
    },
    policyChangeremovedCoveragesEffectiveDate: {
        id: 'e1p.journey.event-templates.policyChange-removedCoverages.Effective Date',
        defaultMessage: 'Effective Date'
    },
    policyChangechangedCoveragesPolicyCoverageChanged: {
        id: 'e1p.journey.event-templates.policyChange-changedCoverages.Policy Coverage Changed',
        defaultMessage: 'Policy Coverage Changed'
    },
    policyChangechangedCoveragesEffectiveDate: {
        id: 'e1p.journey.event-templates.policyChange-changedCoverages.Effective Date',
        defaultMessage: 'Effective Date'
    },
    filterPlaceholder: {
        id: 'e1p.gateway.directives.ClaimSummaryDirective.ClaimSummary.Filters',
        defaultMessage: 'Filters'
    },
    transactionPolicyNumber: {
        id: 'e1p.gateway.directives.policy-transaction.Policy Number',
        defaultMessage: 'Policy Number'
    },
    allTransaction: {
        id: 'e1p.gateway.views.policy-detail.All',
        defaultMessage: 'All'
    },
    draftTransaction: {
        id: 'e1p.gateway.views.policy-detail.Draft',
        defaultMessage: 'Draft'
    },
    noOpenTransaction: {
        id: 'e1p.gateway.views.account-landing.No results found for this filter',
        defaultMessage: 'No results found for this filter'
    },
    noPoliciesForAccount: {
        id: 'e1p.gateway.directives.account-detail.There are no policies on this account',
        defaultMessage: 'There are no policies on this account'
    },
    setupAutomaticPaymentMessage: {
        id: 'e1p.billing.view.setup-stream-autopay.Enabling Automatic Payments Description',
        defaultMessage: 'Enabling Automatic Payments will mean that, starting with the next payment, the current balance due on your account will be paid on the due date specified on the schedule, using the specified payment method. If you have provided an email address in your personal information, you will receive a confirmation email when the payment has been processed or if there were any issues with your payment.'
    },
    setupAutomaticPaymentSchedule: {
        id: 'e1p.billing.view.setup-stream-autopay.Automatic Payment Schedule For Name',
        defaultMessage: 'Automatic Payment Schedule For {displayName}'
    },
    setupAutomaticPaymentNoPending: {
        id: 'e1p.billing.view.setup-stream-autopay.You have no pending payments in this group',
        defaultMessage: 'You have no pending payments in this group'
    },
    scheduleTermTitle: {
        id: 'e1p.gateway.views.gateway-setup-stream-autopay.Payment schedule is',
        defaultMessage: 'Payment schedule is'
    },
    scheduleTermDescription: {
        id: 'e1p.billing.view.setup-stream-autopay.Schedule Term Description',
        defaultMessage: '{periodicity} starting on {startDate}'
    },
    yourPaymentSchedule: {
        id: 'e1p.billing.view.setup-stream-autopay.Your payment schedule is',
        defaultMessage: 'Your payment schedule is:'
    },
    premiumAmount: {
        id: 'e1p.billing.view.setup-stream-autopay.Premium Amount',
        defaultMessage: 'Premium Amount:'
    },
    showDetailedSchedule: {
        id: 'e1p.billing.view.setup-stream-autopay.Show Detailed Schedule',
        defaultMessage: 'Show Detailed Schedule'
    },
    hideDetailedSchedule: {
        id: 'e1p.billing.view.setup-stream-autopay.Hide Detailed Schedule',
        defaultMessage: 'Hide Detailed Schedule'
    },
    invoicePolicyDetails: {
        id: 'e1p.billing.directives.templates.billing-line-policies-summary.Invoice Policy Details',
        defaultMessage: 'Invoice Policy Details'
    },
    detailedScheduleDueDate: {
        id: 'e1p.billing.view.setup-stream-autopay.Due date',
        defaultMessage: 'Due date'
    },
    detailedScheduleBillStatus: {
        id: 'e1p.billing.view.setup-stream-autopay.Bill Status',
        defaultMessage: 'Bill Status'
    },
    detailedSchedulePaidStatus: {
        id: 'e1p.billing.view.setup-stream-autopay.Paid Status',
        defaultMessage: 'Paid Status'
    },
    detailedSchedulePremium: {
        id: 'e1p.billing.view.setup-stream-autopay.Premium',
        defaultMessage: 'Premium'
    },
    detailedScheduleCharges: {
        id: 'e1p.billing.view.setup-stream-autopay.Charges',
        defaultMessage: 'Charges'
    },
    detailedScheduleTotalPaid: {
        id: 'e1p.billing.view.setup-stream-autopay.Total Paid',
        defaultMessage: 'Total Paid'
    },
    detailedScheduleOutstanding: {
        id: 'e1p.billing.view.setup-stream-autopay.Outstanding Amount',
        defaultMessage: 'Outstanding Amount'
    },
    detailedScheduleInvoice: {
        id: 'e1p.billing.view.setup-stream-autopay.Invoice Num',
        defaultMessage: 'Invoice #'
    },
    paymentMethod: {
        id: 'e1p.billing.view.setup-stream-autopay.Payment Method',
        defaultMessage: 'Payment Method'
    },
    setupPaymentCancel: {
        id: 'e1p.billing.view.setup-stream-autopay.Cancel',
        defaultMessage: 'Cancel'
    },
    setupPaymentConfirm: {
        id: 'e1p.billing.view.setup-stream-autopay.Set up Automatic Payments Now',
        defaultMessage: 'Set up Automatic Payments Now'
    },
    setupPaymentConfirmTitle: {
        id: 'e1p.billing.view.setup-autopay-confirmation.Automatic Payments',
        defaultMessage: 'Automatic Payments'
    },
    setupPaymentConfirmMessage: {
        id: 'e1p.billing.view.setup-autopay-confirmation.Automatic payments enabled',
        defaultMessage: 'Automatic payments enabled.'
    },
    setupPaymentConfirmPhone: {
        id: 'e1p.billing.view.setup-autopay-confirmation.If you want to disable automatic payments please contact us at',
        defaultMessage: 'If you want to disable automatic payments, please contact us at {supportPhone}.'
    },
    setupPaymentConfirmRreturn: {
        id: 'e1p.billing.view.setup-autopay-confirmation.Return',
        defaultMessage: 'Return'
    },
    setupPaymentConfirmNextPayment: {
        id: 'e1p.amp.bc3.directives.templates.autopay-summary.next-payment',
        defaultMessage: 'Next payment: {currencyAmount}'
    },
    setupPaymentConfirmDue: {
        id: 'e1p.amp.bc3.directives.templates.autopay-summary.due',
        defaultMessage: 'Due: {dueDate}'
    },
    primaryNumber: {
        id: 'e1p.gateway.directives.contactphone-details.Primary number',
        defaultMessage: 'Primary number'
    },
    noWorkOrderMessage: {
        id: 'e1p.gateway.directives.policy-transaction.There are no work orders matching these filters',
        defaultMessage: 'There are no work orders matching these filters:'
    },
    invalidPhoneMessage: {
        id: 'e1p.gateway.views.The provided phone number is not valid',
        defaultMessage: 'The provided phone number is not valid'
    },
    setupPaymentFailed: {
        id: 'e1p.billing.controllers.SetupStreamAutopayCtrl.Account update failed',
        defaultMessage: 'Account update failed'
    },
    setupPaymentFailedSorry: {
        id: 'e1p.billing.controllers.SetupStreamAutopayCtrl.Sorry, we were not able to setup automatic payments on your account',
        defaultMessage: 'Sorry, we were not able to setup automatic payments on your account'
    },
    automaticPaymentMessage: {
        id: 'e1p.gateway.views.gateway-setup-stream-autopay.Enabling Automatic Payments Description',
        defaultMessage: 'Enabling Automatic Payments will mean that, starting with the next payment, the current balance due on the customers account will be paid on the due date specified on the schedule, using the specified payment method. If customer has provided an email address in their personal information, they will receive a confirmation email when the payment has been processed or if there were any issues with the payment'
    },
    PersonalAuto: {
        id: 'e1p.templates.views.Personal Auto',
        defaultMessage: 'Personal Auto'
    },
    Homeowners: {
        id: 'e1p.templates.views.Homeowners',
        defaultMessage: 'Homeowners'
    },
    Condominium: {
        id: 'e1p.templates.views.Condominium',
        defaultMessage: 'Condominium'
    },
    Renters: {
        id: 'e1p.templates.views.Renters',
        defaultMessage: 'Renters'
    },
    Seasonal: {
        id: 'e1p.templates.views.Seasonal or Secondary',
        defaultMessage: 'Seasonal or Secondary'
    },
    Umbrella: {
        id: 'e1p.templates.views.Umbrella',
        defaultMessage: 'Umbrella'
    },
    ProducerInformation: {
        id: 'e1p.gateway.views.account-detail.Producer Information',
        defaultMessage: 'Producer Information'
    },
    PartnerInformation: {
        id: 'e1p.gateway.views.account-detail.Partner Information',
        defaultMessage: 'Partner Information'
    },
    Partner: {
        id: 'e1p.gateway.views.account-detail.Partner',
        defaultMessage: 'Partner: '
    },
    openSubmissions: {
        id: 'e1p.gateway.views.account-detail.Open Submissions',
        defaultMessage: 'Open Submissions'
    },
    openRewrites: {
        id: 'e1p.gateway.views.account-detail.Open Rewrites',
        defaultMessage: 'Open Rewrites'
    },

});
